'use client'

import { BreadCrumb } from '@circlefin/components/lib/BreadCrumb'

export const CWBreadCrumb = BreadCrumb
export const CWBreadCrumbItem = BreadCrumb.Item
